/**
 * creditPackages.js
 *
 * Single source of truth for credit package definitions and helpers.
 * Import this wherever package data or name-mapping is needed.
 */

export const creditPackages = [
  {
    id: 'starter',
    name: 'Starter Pack',
    credits: 10,
    price: 9.99,
    pricePerCredit: 1.00,
    popular: false,
    savings: null,
    features: [
      '10 photo analysis credits',
      'Valid for 6 months',
      'All ranking features',
    ],
  },
  {
    id: 'popular',
    name: 'Popular Pack',
    credits: 25,
    price: 19.99,
    pricePerCredit: 0.80,
    popular: true,
    savings: '20% savings',
    features: [
      '25 photo analysis credits',
      'Valid for 12 months',
      'All ranking features',
      'Priority email support',
      'Advanced comparison tools',
    ],
  },
  {
    id: 'pro',
    name: 'Pro Pack',
    credits: 50,
    price: 34.99,
    pricePerCredit: 0.70,
    popular: false,
    savings: '30% savings',
    features: [
      '50 photo analysis credits',
      'Valid for 12 months',
      'All ranking features',
      'Priority support',
      'Advanced comparison tools',
      'Export & sharing features',
    ],
  },
];

/**
 * Maps a credit count to a human-readable package name.
 * Used when the package_id is not stored directly (e.g. legacy purchases).
 *
 * @param {number} credits
 * @returns {string}
 */
export const getPackageName = (credits) => {
  if (credits <= 10) return 'Starter Pack';
  if (credits <= 25) return 'Popular Pack';
  return 'Pro Pack';
};
